import { API_URL } from "../../constants/pathConstants"
import { instructorStateData } from "../../data/instructorStateData"
import { InstructorReviewsResponse } from "../types"

class InstructorReviewConnector {
	requestInProgress: boolean = false

	public async performGetReviewsRequest(instructorId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InstructorSearchConnector] performSearchRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("instructorId", instructorId)

				await fetch(`${API_URL}get-instructors-reviews?${urlParams}`)
					.then((res) => res.json())
					.then((data: InstructorReviewsResponse) => {
						if (data.reviews) {
							instructorStateData.addReviews(data.reviews)
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InstructorReviewConnector] - performGetReviewsRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const instructorReviewConnector: InstructorReviewConnector = new InstructorReviewConnector()